<p-panel>
    <ng-template pTemplate="header">
        <h3 class="my-auto"><b>{{ homeDesc.home.titolo }}</b></h3>
    </ng-template>
    <p style="font-size: 1.2rem">
        {{ homeDesc.home.introduzione1 }}
        <a href="https://www.anticorruzione.it/-/comunicato-del-presidente-del-30-marzo-2022">Comunicato del Presidente del 30 marzo 2022.</a>
    </p>
    <p style="font-size: 1.2rem">
        {{ homeDesc.home.introduzione1B }}
        <a href="https://www.anticorruzione.it/-/whistleblowing">https://www.anticorruzione.it/-/whistleblowing</a>
    </p>
    <p style="font-size: 1.2rem">{{ homeDesc.home.introduzione2 }}</p>
    <ul style="font-size: 1.1rem">
        <li>{{ homeDesc.home.list_item1 }}</li>
        <li>{{ homeDesc.home.list_item2 }}</li>
        <li>{{ homeDesc.home.list_item3 }}</li>
    </ul>
    <p style="font-size: 1.2rem">{{ homeDesc.home.introduzione3 }}</p>
    <ul style="font-size: 1.1rem">
        <li><strong>{{ homeDesc.home.list_item4.titolo }}</strong>{{ homeDesc.home.list_item4.desc1 }}<strong>{{ homeDesc.home.list_item4.desc2 }}</strong>{{ homeDesc.home.list_item4.desc3 }}</li>
        <li><strong>{{ homeDesc.home.list_item5.titolo }}</strong>{{ homeDesc.home.list_item5.desc }}</li>
        <li><strong>{{ homeDesc.home.list_item6.titolo }}</strong>{{ homeDesc.home.list_item6.desc }}</li>
        <li><strong>{{ homeDesc.home.list_item7.titolo }}</strong>{{ homeDesc.home.list_item7.desc }}</li>
    </ul>
</p-panel>

<div class="flex flex-row flex-wrap mt-3">
    <div class="flex mr-2">
        <p-button [label]="homeDesc.buttons.prosegui" routerLink="/form"></p-button>
    </div>
    <div *ngIf="!(authService.isAuthenticated$ | async) &&  EnvConfig.auth_SPID && EnvConfig.auth_SPID?.toUpperCase() === 'TRUE'" class="flex ml-2">
        <p-button [label]="homeDesc.buttons.proseguiSPID" (click)="loginSPID()"></p-button>
    </div>
</div>
